import React, { useState } from 'react';
import { Modal, Box, Typography, Button, TextField, Stack, Autocomplete } from '@mui/material';
import axios from 'axios';

function CreateClassModal({open, closeModal, addClass, tokens}) {
    const [className, setClassName] = useState("Senior Design 1");
    const [startSemester, setStartSemester] = useState("");
    const [year, setYear] = useState(new Date().getFullYear());

    const [errorMessage, setErrorMessage] = useState("");
    
    const handleClassNameChange = (event, value) => {
        setClassName(value);
    };

    const handleStartSemesterChange = (event, value) => {
        setStartSemester(value);
    };

    const handleYearChange = (event) => {
        setYear(event.target.value);
    };

    const handleClose = () => {
        setStartSemester("");
        setYear(new Date().getFullYear());
        setErrorMessage("");
        closeModal();
    }

    const getEndSemester = (startSemester) => {
        if (startSemester === 'Spring') return 'Summer';
        if (startSemester === 'Summer') return 'Fall';
        if (startSemester === 'Fall') return 'Spring';
    }
    
    const handleSubmit = async () => {
        if (startSemester === "") {
            setErrorMessage("Please enter start semester and year");
            return;
        }
        const formData = {
            name: className,
            sd1_term: startSemester,
            sd1_year: year,
            sd2_term: getEndSemester(startSemester),
            sd2_year: year,
        }
        axios.post(`${process.env.REACT_APP_API_HOST}/api/class/createClass`, formData, 
        {
            headers: {Authorization: `Bearer ${tokens.access_token}`}
        })
        .then(res => res.data)
        .then(data => {
            formData["class_id"] = data.class_id;
            formData["department"] = data.department;
            addClass(formData);
            handleClose();
        })
        .catch(error =>  setErrorMessage("Could not create new class"));
    };

    const classes = ["Senior Design 1", "Senior Design 2"];
    const semesters = ["Fall", "Spring", "Summer"];

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        width: "60%",
        maxWidth: 550,
        minWidth: 300,
        maxHeight: 650,
        p: 3,
        borderRadius: 1,
        boxShadow: 24,
        overflowX: "auto",
    };

    const inputStyle = {
        width: "100%",
        maxWidth: "100ch",
        alignSelf: "center"
    };

    return (
        <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="create-class-modal"
        aria-describedby="creates-a-new-class"
        disableEnforceFocus
        >
            <Box sx={modalStyle}>
                <Stack spacing={2}>
                    <Typography variant="h4">Create Class</Typography>
                    <Autocomplete
                        id="class-name"
                        options={classes}
                        value={"Senior Design 1"}
                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        autoHighlight
                        autoSelect
                        freeSolo
                        onChange={handleClassNameChange}
                        sx={inputStyle}
                        renderInput={(params) => (
                            <TextField {...params} label="Class name" variant="outlined"/>
                        )}
                    />
                    <Box style={{display: "flex", gap: 30, ...inputStyle}}>
                        <Autocomplete
                            id="start-semester"
                            options={semesters}
                            selectOnFocus
                            clearOnBlur
                            handleHomeEndKeys
                            autoHighlight
                            autoSelect
                            onChange={handleStartSemesterChange}
                            sx={{width: "65%", maxWidth: "50ch",}}
                            renderInput={(params) => (
                            <TextField {...params} label="Semester" variant="outlined"/>
                            )}
                        />
                        <TextField label="Year" type="number" variant="outlined" defaultValue={year} onChange={handleYearChange} style={{width: "35%"}}/>
                    </Box>
                    <Typography style={{textAlign: "center", color: "red"}}>{errorMessage}</Typography>
                    <Stack direction="row" spacing={3} justifyContent="center">
                        <Button variant="outlined" onClick={handleClose} fullWidth>Cancel</Button>
                        <Button variant="contained" onClick={handleSubmit} fullWidth>Submit</Button>
                    </Stack>
                </Stack>
            </Box>
        </Modal>
    );
}

export default CreateClassModal;